module.exports = __webpack_public_path__ + "front/img/1.02ffaa74.png";